<template>
  <div>
    <div class="page-title">Edit List</div>
    <Form v-if="form" v-model="form" :submit="update" btnText="Update List" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.lists.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.List.get({ id: this.$route.params.id });
      this.form = data;
    },
    async update() {
      await this.$api.List.update(this.form);
      this.$router.push("/widgets/lists");
    },
  },
};
</script>

<style></style>
